/*
 * @Date: 2023-04-02 20:28:36
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-13 11:11:29
 * @FilePath: \J1-M3-QRP-CODE\components\QRPComponent\header.js
 */


import React from "react";

export default class Header extends React.Component{
    constructor(){
        super();
        this.state = {

        }
    }


    render(){
        let { pathname } = this.props;
        const {mainSiteUrl,addAffiliateParamToUrl} = this.props;
        return (
            <>
                <div className={'top topweb'}>
					<img src="/static/images/m3-003/JBO-VN-logo.webp" className={'qrp-header-logo'} onClick={()=>{
                        global.location.href = addAffiliateParamToUrl(mainSiteUrl)
                    }} />

                    {pathname && <div className="liveChat" onClick={()=>{this.props.openLiveChat()}}>
						<img src="/static/images/liveChat/icon-cs.png" />
						<span>Live Chat</span>
					</div>}
				</div>

                {/* mobile and ipad */}
				<div className="top tppmobile">
                    <img src="/static/images/m3-003/JBO-VN-logo.webp" className={'qrp-header-logo'} />
                    {pathname &&<div className="liveChat" onClick={()=>{this.props.openLiveChat()}}>
                        <img src="/static/images/liveChat/icon-cs.png" />
                    </div>}
                </div>
            </>
        )
    }
}